var exports = {
  "kL": "x936d19a0--a7aed0--container",
  "Kk": "x936d19a0--a7aed0--icon",
  "Qs": "x936d19a0--a7aed0--content",
};

module.exports = exports;
